import useRibbonActions from './useRibbonActions';
export default useRibbonActions;